export default function Input( props ) {
	//console.log( 'Input', props )
	//console.log( 'input props', props )
	return (
		<input 
			style={{ 
				margin:10, color:'#000', fontSize:18, 
				padding:'6px 12px', fontWeight:600,
				 ...props.style  
			}}
			value={ props.data[ props.item ] || '' }
			placeholder={ props.placeholder || '' } 
			type={ props.type || 'text' }
			onChange={ e => { 
				const d = { ...props.data }
				d[ props.item ] = e.target.value
				//console.log( 'input d', d )
				props.setData( d ) 
			} }
		/>
	)
}